import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_accounts_list = _resolveComponent("accounts-list")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Social Accounts",
    size: "md",
    "body-style": "padding: 0",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_accounts_list, {
        "client-id": _ctx.clientId,
        platforms: _ctx.platforms,
        accounts: _ctx.accounts,
        "onUpdate:accounts": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accounts) = $event)),
        platform: _ctx.platform,
        "onUpdate:platform": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.platform) = $event)),
        class: "bg-grey-2",
        "onUpdate:platforms": _ctx.setPlatforms
      }, null, 8, ["client-id", "platforms", "accounts", "platform", "onUpdate:platforms"])
    ]),
    _: 1
  }, 512))
}